module.exports = __webpack_public_path__ + "img/fr.61718161.svg";